var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["cartNotesQuery"]: () => (__WEBPACK_EXTERNAL_MODULE__static_graphql_fragments_js_abfbe12f__.cartNotesQuery) });